module.exports = __webpack_public_path__ + "static/media/18ECA23.5d1ac22a.jpg";